export default __webpack_public_path__ + "static/media/scoket.aa27363b.svg";